<template>
  <div class="posts-search">
    <div class="posts-search__form">
      <div class="filters-container">
        <p class="label">Filters:</p>
        <ul class="filter">
          <li>
            <div class="select-container">
              <select
                id="investments"
                name="investments"
                data-size="5"
                class="select-filter"
                v-model="this.selectedInvestments"
                @change="filterPosts()"
              >
                <option value="0">All</option>
                <option
                  v-for="investment in investments"
                  :key="investment.id"
                  :value="investment.id"
                >
                  {{ investment.name }}
                </option>
              </select>
            </div>
          </li>
        </ul>

        <ul class="filter">
          <li>
            <div class="select-container">
              <select
                id="sectors"
                name="sectors"
                data-size="5"
                class="select-filter"
                v-model="this.selectedSectors"
                @change="filterPosts()"
              >
                <option value="0">All Sectors</option>
                <option
                  v-for="sector in sectors"
                  :key="sector.id"
                  :value="sector.id"
                >
                  {{ sector.name }}
                </option>
              </select>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div v-if="!loading && total == 0" class="posts-search__no-results">
      Sorry, there are no portfolios that match the above criteria.
    </div>

    <TransitionGroup
      name="stagged-fade"
      tag="div"
      class="posts-search__results"
    >
      <template v-for="(post, index) in posts" :key="index">
        <div class="posts-search__post">
          <a :href="post.customFields.link">
            <div class="portfolio-item-container">
              <div class="image-container">
                <img
                  :src="post.customFields.featured_image_src"
                  :srcset="post.customFields.featured_image_srcset"
                  sizes="(max-width: 480px) 100vw, 50vw"
                  :alt="post.customFields.featured_image_alt"
                  loading="lazy"
                />
              </div>

              <div class="logo-container">
                <img :src="post.customFields.white_logo" loading="lazy" />
              </div>

              <div class="content-container">
                <h3 class="card-title" v-html="post.title"></h3>
                <p>{{ post.customFields.sub_heading }}</p>

                <p class="category">
                  {{ post.customFields.portfolio_sectors_category }}
                </p>
              </div>
            </div>
          </a>
        </div>
      </template>
    </TransitionGroup>

    <div v-if="loading" class="posts-search__loading-spinner"></div>

    <div v-if="!loading && showMore" class="posts-search__load-more">
      <div @click="getMorePosts" class="button">Load more</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    config: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  components: {},
  data() {
    return {
      posts: [],
      sectors: [],
      investments: [],
      years: [],
      params: {
        page: 1,
        per_page: 100,
        orderby: "title",
        order: "asc",
        portfolio_investments: 0,
        portfolio_sectors: 0,
      },
      keywords: "",
      selectedSectors: "0",
      selectedInvestments: "0",
      loading: false,
      total: 10,
      totalPages: 0,
      staggerDelay: 50,
      paginationType: "loadMore",
      keywordSearch: false,
    };
  },
  mounted() {
    this.getSectors();
    this.getInvestments();
    this.getPosts();
  },
  computed: {
    showMore() {
      return this.params.page < this.totalPages || this.loading;
    },
    showing() {
      return (
        "<span>" +
        ((this.params.page - 1) * this.params.per_page +
          1 +
          "</span> to <span>" +
          ((this.params.page - 1) * this.params.per_page +
            this.params.per_page) +
          "</span> of <span>" +
          this.total +
          "</span> results")
      );
    },
  },
  methods: {
    isNumeric: function (n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    },
    async getSectors() {
      this.loading = true;

      await this.axios
        .get("portfolio_sectors", { perPage: -1 })
        .then((response) => {
          this.sectors = response.data;
        });

      this.loading = false;
    },
    async getInvestments() {
      this.loading = true;

      await this.axios
        .get("portfolio_investments", { perPage: -1 })
        .then((response) => {
          this.investments = response.data;
        });

      this.loading = false;
    },

    async getPosts() {
      this.loading = true;

      const params = { ...this.params };

      if (this.selectedSectors !== "0") {
        params.portfolio_sectors = this.selectedSectors;
      } else {
        delete params.portfolio_sectors;
      }

      if (this.selectedInvestments !== "0") {
        params.portfolio_investments = this.selectedInvestments;
      } else {
        delete params.portfolio_investments;
      }

      await this.axios
        .get("portfolio", {
          params,
        })
        .then((response) => {
          const posts = [];

          response.data.forEach((post) => {
            posts.push({
              link: post.link,
              title: post.title.rendered,
              excerpt: post.excerpt.rendered,
              date: post.formatted_date,
              customFields: post.custom_fields,
            });
          });
          this.posts = this.posts.concat(posts);
          this.total = parseInt(response.headers["x-wp-total"], 10);
          this.totalPages = parseInt(response.headers["x-wp-totalpages"], 10);
        });

      this.loading = false;
    },
    async getMorePosts() {
      this.params.page += 1;
      this.loading = true;

      const params = { ...this.params };

      if (this.selectedSectors !== "0" && this.selectedSectors !== 0) {
        params.portfolio_sectors = this.selectedSectors;
      } else {
        delete params.portfolio_sectors;
      }

      if (this.selectedInvestments !== "0" && this.selectedInvestments !== 0) {
        params.portfolio_investments = this.selectedInvestments;
      } else {
        delete params.portfolio_investments;
      }

      await this.axios
        .get("portfolio", {
          params,
        })
        .then((response) => {
          const morePosts = [];

          response.data.forEach((post) => {
            morePosts.push({
              link: post.link,
              title: post.title.rendered,
              excerpt: post.excerpt.rendered,
              date: post.formatted_date,
              customFields: post.custom_fields,
            });
          });
          this.posts = this.posts.concat(morePosts);
        });

      this.loading = false;
    },
    filterPosts() {
      this.posts = [];
      this.params.page = 1;
      this.getPosts();
    },
    beforeEnter(el) {
      el.style.opacity = 0;
    },
    onEnter(el) {
      const delay = el.dataset.index * this.staggerDelay;
      setTimeout(() => {
        el.style.opacity = 1;
      }, delay);
    },
    onLeave(el) {
      el.style.display = "none";
    },
    paginationCallback(pageNumber) {
      this.params.page = pageNumber;
      // history.pushState(
      //   this.params.page,
      //   'null',
      //   window.location.pathname + '?pl=' + this.params.page,
      // );

      // // Jump to search results.
      // let top = document.getElementById('results-top').offsetTop;
      // window.scrollTo(0, top - 300);

      this.filterPaginationPosts();
    },
  },
};
</script>
